import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import DevolucionWizard from "../DevolucionWizard";

export default function DevolucionContainer() {
    const {state, search} = useLocation();
    const navigate = useNavigate();
    const [ventaId, setVentaId] = useState(null);

    useEffect(() => {
        const ventaIdFromState = state?.ventaId;
        const queryParams = new URLSearchParams(search)
        setVentaId( ventaIdFromState || queryParams?.get('ventaId') );
    }, [state, search]);
   
    return (
        <div className="w-100 content">
            <div className="w-100">
                <div className="w-100 mb-4">
                    <button type="button" className="btn btn-add" onClick={() => navigate(-1)}>
                        <span className="add">
                            <FontAwesomeIcon icon={faLongArrowAltLeft} size="1x" className="action" color="#215732" />
                        </span>
                        Atrás
                    </button>
                </div>

                {ventaId && <DevolucionWizard ventaId={ventaId}></DevolucionWizard>}
            </div>
      </div>
    );
}